/**
 * Sign-up mode and waitlist (backend `bat.api.waitlist`).
 *
 * - GET  /api/auth/signup-mode        public: {mode, consentVersion}
 * - POST /api/waitlist                public: always 202 with the same body (no enumeration)
 * - POST /api/waitlist/confirm        public: {token} from the mailed link (double opt-in)
 * - POST /api/waitlist/unsubscribe    public: {token}: deletes the entry (GDPR Art. 17)
 *
 * Confirm/unsubscribe are POSTs made by the pages the mailed links open, so a
 * mail scanner prefetching the link never confirms or erases anything.
 */

import { apiService } from '@/platform/api/api.service'

export type SignupMode = 'open' | 'waitlist' | 'invite-only'

export interface SignupModeResponse {
  mode: SignupMode
  consentVersion: string
}

export interface JoinWaitlistRequest {
  email: string
  consent: boolean
  locale?: string
  source?: string
  utmSource?: string
  utmMedium?: string
  utmCampaign?: string
  referrer?: string
  /** Honeypot: hidden from people; a bot filling it is answered alike and nothing is stored. */
  website?: string
}

export async function getSignupMode(): Promise<SignupModeResponse> {
  const response = await apiService.get<SignupModeResponse>('/api/auth/signup-mode', undefined, true)
  return response.data
}

export async function joinWaitlist(request: JoinWaitlistRequest): Promise<void> {
  await apiService.post('/api/waitlist', request, undefined, true)
}

export async function confirmWaitlist(token: string): Promise<void> {
  await apiService.post('/api/waitlist/confirm', { token }, undefined, true)
}

export async function unsubscribeWaitlist(token: string): Promise<void> {
  await apiService.post('/api/waitlist/unsubscribe', { token }, undefined, true)
}
